// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-logout_modal__F50wQ","buttons":"modal-logout_buttons__pzCP7","confirm_button":"modal-logout_confirm_button__OsaFz"};